var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},[_c('v-calendar',{attrs:{"attributes":_vm.attrs,"minDate":_vm.minDate,"maxDate":_vm.maxDate,"weeksTransition":"none","titleTransition":"none"}}),_c('ul',{staticClass:"caption"},_vm._l((_vm.content.caption),function(item,i){return _c('li',{key:i},[_c('div',{staticClass:"color",style:({
          backgroundColor: item.color,
          border: item.color
        })}),_c('p',{domProps:{"innerHTML":_vm._s(item.text)}})])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }